"use client";

import React from "react";
import { Link } from "@/components/common/Link";
import { MenuProvider, useMenu } from "@/integrations/wordpress/WordPressMenuProvider";
import { Linkedin } from "lucide-react";
function FooterMenuConsumer() {
  const {
    menuItems,
    loading
  } = useMenu();
  if (loading) {
    return <div className="flex flex-col gap-4">
        {[1, 2, 3, 4].map(i => <div key={i} data-index={i} className="h-5 w-24 animate-pulse rounded bg-muted/20" />)}
      </div>;
  }
  if (!menuItems || menuItems.length === 0) {
    return null;
  }
  return <nav className="flex flex-col gap-3">
      {menuItems.map((item, i) => <div key={item.id} data-index={i}>
          <Link to={item.href || "#"} className="group relative inline-block w-fit text-sm font-medium text-foreground/90 transition-colors hover:text-primary">
            {item.label}
            <span className="absolute -bottom-1 left-0 h-px w-0 bg-primary transition-all duration-500 ease-out group-hover:w-full" />
          </Link>
        </div>)}
    </nav>;
}
export default function Footer() {
  return <section id="footer" className="dark bg-background text-foreground border-t border-primary py-16 lg:py-24">
      <div className="container mx-auto px-6 md:px-12">
        <div className="grid grid-cols-1 gap-12 lg:grid-cols-4 lg:gap-8">
          {}
          <div className="flex flex-col gap-6">
            <Link to="/" className="block w-fit">
              <img src="https://wpvc-images.s3.us-east-1.amazonaws.com/images/1552867/img/expat_legacy_logo_white.png" alt="Expat Legacy Logo" className="h-7 w-auto object-contain" />
            </Link>
            <p className="text-sm leading-relaxed text-muted-foreground max-w-xs">
              Our mission is to build solid foundations for a chosen, sovereign,
              and internationally aligned life — structured for long-term
              clarity, resilience, and freedom.
            </p>
          </div>

          {}
          <div className="flex flex-col gap-6">
            <h3 className="text-sm font-semibold uppercase tracking-wider text-primary">
              Explore
            </h3>
            <MenuProvider menu_id="18" className="w-full">
              <FooterMenuConsumer />
            </MenuProvider>
          </div>

          {}
          <div className="flex flex-col gap-6">
            <h3 className="text-sm font-semibold uppercase tracking-wider text-primary">
              Connect
            </h3>
            <Link to="https://www.linkedin.com" newTab className="group flex items-center gap-3 text-sm font-medium text-foreground/90 transition-colors hover:text-primary w-fit">
              <div className="flex h-10 w-10 items-center justify-center rounded-full border border-primary/30 bg-primary/5 text-primary transition-all duration-500 group-hover:border-primary group-hover:bg-primary group-hover:text-background">
                <Linkedin className="h-5 w-5" strokeWidth={1.5} />
              </div>
              <span className="relative">
                LinkedIn
                <span className="absolute -bottom-1 left-0 h-px w-0 bg-primary transition-all duration-500 ease-out group-hover:w-full" />
              </span>
            </Link>
          </div>

          {}
          <div className="flex flex-col gap-6">
            <h3 className="text-sm font-semibold uppercase tracking-wider text-primary">
              Legal
            </h3>
            <div className="space-y-4 text-[10px] leading-relaxed text-muted-foreground/60">
              <p>
                Expat Legacy is an international advisory firm. We do not
                provide legal or tax advice in jurisdictions where we are not
                licensed. All services are coordinated through a network of
                independent professionals and compliant legal entities.
              </p>
              <p>
                Atlas Legacy Consulting LLC
                <br />
                2104 House Ave, Cheyenne WY 82001
              </p>
              <p>
                © {new Date().getFullYear()} Expat Legacy. All rights reserved.
              </p>
            </div>
          </div>
        </div>
      </div>
    </section>;
}